/**
 * 检查结果
 */
export default class CheckResult {
    /**
     * 构造方法
     * @param  {class}     checkRule 检查规则
     * @param  {string}    message   检查结果信息
     * @param  {integer}   level     检查结果等级
     */
    constructor(checkRule, message = checkRule.description, level = checkRule.level) {
        /**
         * 检查规则id
         * @type {string}
         */
        this.rule = checkRule;
        /**
         * 检查结果错误信息
         * @type {string}
         */
        this.message = message;
        /**
         * 错误等级
         * @type {integer}
         */
        this.level = level;
        /**
         * 检查时机，0.未知；1：运行时；2.工具完成finish时
         * @type {String}
         */
        this.situation = 0;
    }

    /**
     * 比较方法
     * @param  {object} other 另一个检查结果
     * @return {boolean} 通过比较返回true，不通过返回false
     */
    equal(other) {
        if (this.rule !== other.rule) {
            return false;
        }
        if (this.situation !== other.situation) {
            return false;
        }
        if (this.message !== other.message) {
            return false;
        }
        if (this.level !== other.level) {
            return false;
        }

        return true;
    }
}
